import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RITEL_INVESTOR } from '../models/investor';
import { ACCOUNTS } from '../models/account';
import { HeaderService } from '../header.service';
import { ProfileService } from '../profile.service';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import * as Globals from '../globals';
import { ExcelService } from 'app/excel.service';
declare var $: any;

@Component({
  selector: 'app-investor',
  templateUrl: './investor.component.html',
  styleUrls: ['./investor.component.css']
})
export class InvestorComponent implements OnInit {

  loading: boolean;
  userProfile: any;
  invId: number;
  search: string = '';
  idtyNo: string = '';
  authMenu: any;
  sid: string = '';
  investors: RITEL_INVESTOR[];
  colSort: string[] = ['INV_NAME'];
  reverse: boolean = false;
  col: number = 1;
  p: number = 1;
  tab: number = 1;
  formActive:boolean = false;
  rawinvestor : any[];

  constructor(private http: Http, public toastr: ToastsManager, vRef: ViewContainerRef, private headerService: HeaderService, private profileService: ProfileService, private route: ActivatedRoute, private router: Router, private excelService: ExcelService) {
    this.toastr.setRootViewContainerRef(vRef);
    this.authMenu = { M_FLAG: null };
    this.router.events.subscribe(event => {
      if (event instanceof RoutesRecognized) {
        if (event.url == '/auction/investor/0') {
          this.tab = 1;
          this.router.navigate(['/auction/investor/1']);
        }
      };
    });
  }
  ngOnInit() {
    let id = +this.route.snapshot.params['id'];
    if (id == 0) {
      this.router.navigate(['/auction/investor/1']);
    }
    this.investors = [];
    if (!this.profileService.userProfile) {
      this.profileService.signOut();
    } else {
      this.userProfile = this.profileService.userProfile;
      if( this.userProfile.PA_ID == null ) { this.getInvestors(); }      
      this.authMenu = Globals.getAuthMenu(103, this.userProfile);
    }
  }
  sort(val: number) {
    this.col = val;
    this.reverse = !this.reverse;
    switch (val) {
      case 1:
        this.colSort = ['INV_NAME'];
        if (!this.reverse) {
          this.colSort = ['-INV_NAME'];
        }
        break;
      case 2:
        this.colSort = ['IDTY_NO'];
        break;
      case 3:
        this.colSort = ['BIRTH_PLACE'];
        break;
      case 4:
        this.colSort = ['BIRTH_DATE'];
        break;
      case 5:
        this.colSort = ['ADDRESS'];
        break;
      default:
        break;
    }
  }
  getInvestors() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/investor?skip=0&take=50&search=' + this.search + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res) => {
        this.investors = res.json();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  refreshParent(event: any) {
    this.getInvestors();
    this.invId = event.invId;
    this.sid = event.sid;
    this.idtyNo = event.idtyNo;
    if (event.mode === 0) {
      this.tab = 1;
    }
  }

  getRawInvestor() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/onlineinvestor?t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.rawinvestor = res.json();
        this.excelService.exportAsExcelFile(this.rawinvestor, 'Investor');
        //onsole.log(this.series);
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/investor/investor.component.ts